import { typeCheckAppModule } from "../../../core/utils";
import { NAME } from "./constants";
import { GenericFormPage } from "./GenericFormPage";

export const genericFormPage = typeCheckAppModule({
    NAME,
    Container: GenericFormPage,
});
